import { Howl } from 'howler';
import { useEffect, useEffectEvent } from 'react';

interface Options {
  when?: boolean;
}

const useSoundEffect = (options: Options = {}, dependencies = []) => {
  const { when } = options;
  const playSound = useEffectEvent(() => {
    if (when) {
      const sound = new Howl({
        src: 'https://cdn.guuru.com/assets/sounds/newChatMessageSound.mp3',
        onunlock: () => {
          sound.volume(0.0);
          sound.once('end', () => sound.volume(1.0));
        },
      });
      sound.play();
    }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => playSound(), dependencies);
};

export default useSoundEffect;
